import React from 'react';
import LegalLayout from '../legal/LegalLayout';
import { CookieIllustration } from '../legal/illustrations';
import {
  getCategoryMeta,
  getCookieLanguage,
  isMobileAppWebView,
  openCookieSettings,
} from '../legal/cookieConsent';

type CookiePolicyCopy = {
  eyebrow: string;
  title: string;
  intro: string;
  sections: {
    whatTitle: string;
    whatBody: string;
    legalTitle: string;
    legalBody: string;
    categoriesTitle: string;
    servicesTitle: string;
    servicesBody: string;
    manageTitle: string;
    manageBody: string;
    browserBody: string;
    iosNoTracking: string;
    openSettings: string;
    note: string;
  };
  table: {
    provider: string;
    purpose: string;
    category: string;
    essential: string;
    functional: string;
    analytics: string;
    marketing: string;
    mainEventsPurpose: string;
    stripePurpose: string;
    paypalPurpose: string;
    googleMapsPurpose: string;
    firebasePurpose: string;
    analyticsPurpose: string;
    marketingPurpose: string;
  };
};

const COPY: Record<string, CookiePolicyCopy> = {
  de: {
    eyebrow: 'Rechtliches',
    title: 'Cookie-Richtlinie',
    intro: 'Wie Main Events Cookies und ähnliche Technologien einsetzt und wie du deine Einwilligung jederzeit anpassen kannst.',
    sections: {
      whatTitle: '1. Was sind Cookies?',
      whatBody: 'Cookies sind kleine Textdateien, die auf deinem Endgerät gespeichert werden, wenn du unsere Plattform nutzt. Ähnliche Technologien wie Local Storage erfüllen vergleichbare Zwecke. Sie helfen uns, die Plattform funktionsfähig, sicher und benutzerfreundlich zu machen.',
      legalTitle: '2. Rechtsgrundlage',
      legalBody: 'Essenzielle Cookies setzen wir ein, um die Plattform bereitzustellen und sicher zu betreiben. Optionale Cookies werden nur mit deiner Einwilligung verwendet. Deine Einwilligung ist freiwillig und kann jederzeit mit Wirkung für die Zukunft geändert oder widerrufen werden.',
      categoriesTitle: '3. Cookie-Kategorien',
      servicesTitle: '4. Eingesetzte Dienste und Cookies',
      servicesBody: 'Die folgende Übersicht zeigt wichtige Anbieter, deren Technologien auf Main Events zum Einsatz kommen können. Details zur Verarbeitung findest du in unserer Datenschutzerklärung.',
      manageTitle: '5. Einwilligung verwalten',
      manageBody: 'Du kannst deine Auswahl jederzeit ändern oder widerrufen. Öffne dazu die Cookie-Einstellungen:',
      browserBody: 'Alternativ kannst du Cookies in den Einstellungen deines Browsers verwalten oder löschen. Bitte beachte, dass dann möglicherweise nicht mehr alle Funktionen der Plattform zur Verfügung stehen.',
     openSettings: 'Cookie-Einstellungen öffnen',
     iosNoTracking: 'Wir verwenden keine Cookies für Tracking- oder Werbezwecke und verfolgen dich nicht über Apps oder Websites anderer Unternehmen hinweg.',
      note: 'Hinweis: Marketing- und Werbe-Cookies werden nicht verwendet.',
      },
    table: {
      provider: 'Anbieter',
      purpose: 'Zweck',
      category: 'Kategorie',
      essential: 'Essenziell',
      functional: 'Funktional',
      analytics: 'Statistik',
      marketing: 'Marketing',
      mainEventsPurpose: 'Login, Sitzung, Warenkorb, Sicherheit',
      stripePurpose: 'Zahlungsabwicklung und Betrugsprävention',
      paypalPurpose: 'Zahlungsabwicklung, sofern verfügbar',
      googleMapsPurpose: 'Karten, Veranstaltungsorte, Sitzplan-Ansicht',
      firebasePurpose: 'Push-Benachrichtigungen',
      analyticsPurpose: 'Pseudonymisierte Nutzungsanalyse zur Verbesserung der Plattform',
      marketingPurpose: 'Personalisierte Inhalte und Werbung',
    },
  },
  'de-AT': {
    eyebrow: 'Rechtliches',
    title: 'Cookie-Richtlinie',
    intro: 'Wie Main Events Cookies und ähnliche Technologien einsetzt und wie du deine Einwilligung jederzeit anpassen kannst.',
    sections: {
      whatTitle: '1. Was sind Cookies?',
      whatBody: 'Cookies sind kleine Textdateien, die auf deinem Endgerät gespeichert werden, wenn du unsere Plattform nutzt. Ähnliche Technologien wie Local Storage erfüllen vergleichbare Zwecke. Sie helfen uns, die Plattform funktionsfähig, sicher und benutzerfreundlich zu machen.',
      legalTitle: '2. Rechtsgrundlage',
      legalBody: 'Essenzielle Cookies setzen wir ein, um die Plattform bereitzustellen und sicher zu betreiben. Optionale Cookies werden nur mit deiner Einwilligung verwendet. Deine Einwilligung ist freiwillig und kann jederzeit mit Wirkung für die Zukunft geändert oder widerrufen werden.',
      categoriesTitle: '3. Cookie-Kategorien',
      servicesTitle: '4. Eingesetzte Dienste und Cookies',
      servicesBody: 'Die folgende Übersicht zeigt wichtige Anbieter, deren Technologien auf Main Events zum Einsatz kommen können. Details zur Verarbeitung findest du in unserer Datenschutzerklärung.',
      manageTitle: '5. Einwilligung verwalten',
      manageBody: 'Du kannst deine Auswahl jederzeit ändern oder widerrufen. Öffne dazu die Cookie-Einstellungen:',
      browserBody: 'Alternativ kannst du Cookies in den Einstellungen deines Browsers verwalten oder löschen. Bitte beachte, dass dann möglicherweise nicht mehr alle Funktionen der Plattform zur Verfügung stehen.',
      openSettings: 'Cookie-Einstellungen öffnen',
      iosNoTracking: 'Wir verwenden keine Cookies für Tracking- oder Werbezwecke und verfolgen dich nicht über Apps oder Websites anderer Unternehmen hinweg.',
      note: 'Hinweis: Marketing- und Werbe-Cookies werden nicht verwendet.',
    },
    table: {
      provider: 'Anbieter',
      purpose: 'Zweck',
      category: 'Kategorie',
      essential: 'Essenziell',
      functional: 'Funktional',
      analytics: 'Statistik',
      marketing: 'Marketing',
      mainEventsPurpose: 'Login, Sitzung, Warenkorb, Sicherheit',
      stripePurpose: 'Zahlungsabwicklung und Betrugsprävention',
      paypalPurpose: 'Zahlungsabwicklung, sofern verfügbar',
      googleMapsPurpose: 'Karten, Veranstaltungsorte, Sitzplan-Ansicht',
      firebasePurpose: 'Push-Benachrichtigungen',
      analyticsPurpose: 'Pseudonymisierte Nutzungsanalyse zur Verbesserung der Plattform',
      marketingPurpose: 'Personalisierte Inhalte und Werbung',
    },
  },
  en: {
    eyebrow: 'Legal',
    title: 'Cookie Policy',
    intro: 'How Main Events uses cookies and similar technologies, and how you can adjust your consent at any time.',
    sections: {
      whatTitle: '1. What are cookies?',
      whatBody: 'Cookies are small text files stored on your device when you use our platform. Similar technologies such as local storage serve comparable purposes. They help us keep the platform functional, secure, and user-friendly.',
      legalTitle: '2. Legal basis',
      legalBody: 'We use essential cookies to provide and securely operate the platform. Optional cookies are used only with your consent. Your consent is voluntary and can be changed or withdrawn at any time for the future.',
      categoriesTitle: '3. Cookie categories',
      servicesTitle: '4. Services and cookies used',
      servicesBody: 'The following overview shows important providers whose technologies may be used on Main Events. Details about processing can be found in our Privacy Policy.',
      manageTitle: '5. Manage consent',
      manageBody: 'You can change or withdraw your selection at any time. Open the cookie settings:',
      browserBody: 'Alternatively, you can manage or delete cookies in your browser settings. Please note that some platform functions may then no longer be available.',
      openSettings: 'Open cookie settings',
      iosNoTracking: 'We do not use cookies for tracking or advertising purposes and we do not track you across apps or websites owned by other companies.',
      note: 'Note: Marketing and advertising cookies are not used.',
    },
    table: {
      provider: 'Provider',
      purpose: 'Purpose',
      category: 'Category',
      essential: 'Essential',
      functional: 'Functional',
      analytics: 'Statistics',
      marketing: 'Marketing',
      mainEventsPurpose: 'Login, session, cart, security',
      stripePurpose: 'Payment processing and fraud prevention',
      paypalPurpose: 'Payment processing, where available',
      googleMapsPurpose: 'Maps, venues, seat-map views',
      firebasePurpose: 'Push notifications',
      analyticsPurpose: 'Pseudonymized usage analytics to improve the platform',
      marketingPurpose: 'Personalized content and advertising',
    },
  },
  es: {
    eyebrow: 'Legal',
    title: 'Política de cookies',
    intro: 'Cómo Main Events usa cookies y tecnologías similares, y cómo puedes ajustar tu consentimiento en cualquier momento.',
    sections: {
      whatTitle: '1. ¿Qué son las cookies?',
      whatBody: 'Las cookies son pequeños archivos de texto que se almacenan en tu dispositivo cuando usas nuestra plataforma. Tecnologías similares, como el almacenamiento local, cumplen fines comparables. Nos ayudan a mantener la plataforma funcional, segura y fácil de usar.',
      legalTitle: '2. Base legal',
      legalBody: 'Usamos cookies esenciales para proporcionar y operar la plataforma de forma segura. Las cookies opcionales solo se usan con tu consentimiento. Tu consentimiento es voluntario y puede cambiarse o retirarse en cualquier momento para el futuro.',
      categoriesTitle: '3. Categorías de cookies',
      servicesTitle: '4. Servicios y cookies utilizados',
      servicesBody: 'La siguiente tabla muestra proveedores importantes cuyas tecnologías pueden utilizarse en Main Events. Los detalles sobre el tratamiento se encuentran en nuestra Política de privacidad.',
      manageTitle: '5. Gestionar el consentimiento',
      manageBody: 'Puedes cambiar o retirar tu selección en cualquier momento. Abre la configuración de cookies:',
      browserBody: 'También puedes gestionar o eliminar cookies en la configuración de tu navegador. Ten en cuenta que algunas funciones de la plataforma podrían dejar de estar disponibles.',
      openSettings: 'Abrir configuración de cookies',
      iosNoTracking: 'No usamos cookies con fines de seguimiento o publicidad y no te rastreamos entre apps o sitios web de otras empresas.',
      note: 'Nota: Las cookies de marketing y publicidad no se usan.',
        },
    table: {
      provider: 'Proveedor',
      purpose: 'Finalidad',
      category: 'Categoría',
      essential: 'Esencial',
      functional: 'Funcional',
      analytics: 'Estadística',
      marketing: 'Marketing',
      mainEventsPurpose: 'Inicio de sesión, sesión, carrito, seguridad',
      stripePurpose: 'Procesamiento de pagos y prevención de fraude',
      paypalPurpose: 'Procesamiento de pagos, cuando esté disponible',
      googleMapsPurpose: 'Mapas, lugares, vistas de asientos',
      firebasePurpose: 'Notificaciones push',
      analyticsPurpose: 'Análisis de uso seudonimizado para mejorar la plataforma',
      marketingPurpose: 'Contenido personalizado y publicidad',
    },
  },
  fr: {
    eyebrow: 'Juridique',
    title: 'Politique relative aux cookies',
    intro: 'Comment Main Events utilise les cookies et technologies similaires, et comment modifier votre consentement à tout moment.',
    sections: {
      whatTitle: '1. Que sont les cookies ?',
      whatBody: 'Les cookies sont de petits fichiers texte stockés sur votre appareil lorsque vous utilisez notre plateforme. Des technologies similaires, comme le stockage local, remplissent des fonctions comparables. Elles nous aident à rendre la plateforme fonctionnelle, sécurisée et conviviale.',
      legalTitle: '2. Base juridique',
      legalBody: 'Nous utilisons des cookies essentiels pour fournir et exploiter la plateforme en toute sécurité. Les cookies optionnels ne sont utilisés qu’avec votre consentement. Votre consentement est volontaire et peut être modifié ou retiré à tout moment pour l’avenir.',
      categoriesTitle: '3. Catégories de cookies',
      servicesTitle: '4. Services et cookies utilisés',
      servicesBody: 'Le tableau suivant présente les principaux fournisseurs dont les technologies peuvent être utilisées sur Main Events. Les détails du traitement figurent dans notre Politique de confidentialité.',
      manageTitle: '5. Gérer le consentement',
      manageBody: 'Vous pouvez modifier ou retirer votre sélection à tout moment. Ouvrez les paramètres des cookies :',
      browserBody: 'Vous pouvez également gérer ou supprimer les cookies dans les paramètres de votre navigateur. Certaines fonctions de la plateforme peuvent alors ne plus être disponibles.',
      openSettings: 'Ouvrir les paramètres des cookies',
      iosNoTracking: 'Nous n’utilisons pas de cookies à des fins de suivi ou de publicité et nous ne vous suivons pas sur les apps ou sites web d’autres entreprises.',
      note: 'Remarque : les cookies marketing et publicitaires ne sont pas utilisés.',
    },
    table: {
      provider: 'Fournisseur',
      purpose: 'Finalité',
      category: 'Catégorie',
      essential: 'Essentiel',
      functional: 'Fonctionnel',
      analytics: 'Statistiques',
      marketing: 'Marketing',
      mainEventsPurpose: 'Connexion, session, panier, sécurité',
      stripePurpose: 'Traitement des paiements et prévention de la fraude',
      paypalPurpose: 'Traitement des paiements, si disponible',
      googleMapsPurpose: 'Cartes, lieux, plans de sièges',
      firebasePurpose: 'Notifications push',
      analyticsPurpose: 'Analyse d’usage pseudonymisée pour améliorer la plateforme',
      marketingPurpose: 'Contenu personnalisé et publicité',
    },
  },
  it: {
    eyebrow: 'Legale',
    title: 'Informativa sui cookie',
    intro: 'Come Main Events usa cookie e tecnologie simili e come puoi modificare il consenso in qualsiasi momento.',
    sections: {
      whatTitle: '1. Cosa sono i cookie?',
      whatBody: 'I cookie sono piccoli file di testo salvati sul tuo dispositivo quando usi la nostra piattaforma. Tecnologie simili, come il local storage, hanno scopi comparabili. Ci aiutano a mantenere la piattaforma funzionale, sicura e facile da usare.',
      legalTitle: '2. Base giuridica',
      legalBody: 'Usiamo cookie essenziali per fornire e gestire la piattaforma in modo sicuro. I cookie opzionali vengono usati solo con il tuo consenso. Il consenso è volontario e può essere modificato o revocato in qualsiasi momento per il futuro.',
      categoriesTitle: '3. Categorie di cookie',
      servicesTitle: '4. Servizi e cookie utilizzati',
      servicesBody: 'La seguente panoramica mostra i principali fornitori le cui tecnologie possono essere utilizzate su Main Events. I dettagli sul trattamento sono disponibili nella nostra Informativa sulla privacy.',
      manageTitle: '5. Gestire il consenso',
      manageBody: 'Puoi modificare o revocare la tua scelta in qualsiasi momento. Apri le impostazioni dei cookie:',
      browserBody: 'In alternativa puoi gestire o eliminare i cookie dalle impostazioni del browser. Alcune funzioni della piattaforma potrebbero non essere più disponibili.',
      openSettings: 'Apri impostazioni cookie',
      iosNoTracking: 'Non usiamo cookie per tracciamento o pubblicità e non ti tracciamo tra app o siti web di altre aziende.',
      note: 'Nota: i cookie di marketing e pubblicità non sono usati.',
    },
    table: {
      provider: 'Fornitore',
      purpose: 'Scopo',
      category: 'Categoria',
      essential: 'Essenziale',
      functional: 'Funzionale',
      analytics: 'Statistiche',
      marketing: 'Marketing',
      mainEventsPurpose: 'Login, sessione, carrello, sicurezza',
      stripePurpose: 'Elaborazione pagamenti e prevenzione frodi',
      paypalPurpose: 'Elaborazione pagamenti, se disponibile',
      googleMapsPurpose: 'Mappe, luoghi, viste dei posti',
      firebasePurpose: 'Notifiche push',
      analyticsPurpose: 'Analisi d’uso pseudonimizzata per migliorare la piattaforma',
      marketingPurpose: 'Contenuti personalizzati e pubblicità',
    },
  },
  uk: {
    eyebrow: 'Юридична інформація',
    title: 'Політика cookie',
    intro: 'Як Main Events використовує cookie та подібні технології, і як ви можете змінити згоду в будь-який час.',
    sections: {
      whatTitle: '1. Що таке cookie?',
      whatBody: 'Cookie — це невеликі текстові файли, які зберігаються на вашому пристрої під час використання платформи. Подібні технології, як-от local storage, мають схожі цілі. Вони допомагають забезпечити функціональність, безпеку та зручність платформи.',
      legalTitle: '2. Правова підстава',
      legalBody: 'Ми використовуємо необхідні cookie для надання та безпечної роботи платформи. Необов’язкові cookie використовуються лише за вашою згодою. Згода є добровільною і може бути змінена або відкликана в будь-який час на майбутнє.',
      categoriesTitle: '3. Категорії cookie',
      servicesTitle: '4. Використані сервіси та cookie',
      servicesBody: 'Нижче наведено основних постачальників, чиї технології можуть використовуватися в Main Events. Деталі обробки даних наведено в нашій Політиці конфіденційності.',
      manageTitle: '5. Керування згодою',
      manageBody: 'Ви можете змінити або відкликати свій вибір у будь-який час. Відкрийте налаштування cookie:',
      browserBody: 'Також ви можете керувати cookie або видаляти їх у налаштуваннях браузера. У такому разі деякі функції платформи можуть бути недоступні.',
      openSettings: 'Відкрити налаштування cookie',
      iosNoTracking: 'Ми не використовуємо cookie для відстеження чи реклами та не відстежуємо вас в інших застосунках або на сайтах інших компаній.',
      note: 'Примітка: маркетингові та рекламні cookie не використовуються.',
    },
    table: {
      provider: 'Постачальник',
      purpose: 'Мета',
      category: 'Категорія',
      essential: 'Необхідні',
      functional: 'Функціональні',
      analytics: 'Статистика',
      marketing: 'Маркетинг',
      mainEventsPurpose: 'Вхід, сесія, кошик, безпека',
      stripePurpose: 'Обробка платежів і запобігання шахрайству',
      paypalPurpose: 'Обробка платежів, якщо доступно',
      googleMapsPurpose: 'Карти, місця проведення, схеми місць',
      firebasePurpose: 'Push-сповіщення',
      analyticsPurpose: 'Псевдонімізований аналіз використання для покращення платформи',
      marketingPurpose: 'Персоналізований контент і реклама',
    },
  },
  no: {
    eyebrow: 'Juridisk',
    title: 'Cookie-erklæring',
    intro: 'Hvordan Main Events bruker informasjonskapsler og lignende teknologi, og hvordan du kan endre samtykket ditt når som helst.',
    sections: {
      whatTitle: '1. Hva er cookies?',
      whatBody: 'Cookies er små tekstfiler som lagres på enheten din når du bruker plattformen vår. Lignende teknologier, som local storage, har sammenlignbare formål. De hjelper oss med å holde plattformen funksjonell, sikker og brukervennlig.',
      legalTitle: '2. Rettslig grunnlag',
      legalBody: 'Vi bruker essensielle cookies for å levere og drifte plattformen sikkert. Valgfrie cookies brukes bare med ditt samtykke. Samtykket er frivillig og kan endres eller trekkes tilbake når som helst for fremtiden.',
      categoriesTitle: '3. Cookie-kategorier',
      servicesTitle: '4. Tjenester og cookies som brukes',
      servicesBody: 'Oversikten nedenfor viser viktige leverandører hvis teknologi kan brukes på Main Events. Detaljer om behandlingen finnes i personvernerklæringen vår.',
      manageTitle: '5. Administrer samtykke',
      manageBody: 'Du kan endre eller trekke tilbake valget ditt når som helst. Åpne cookie-innstillingene:',
      browserBody: 'Du kan også administrere eller slette cookies i nettleserinnstillingene. Noen funksjoner på plattformen kan da bli utilgjengelige.',
      openSettings: 'Åpne cookie-innstillinger',
      iosNoTracking: 'Vi bruker ikke cookies til sporing eller reklame, og vi sporer deg ikke på tvers av apper eller nettsteder eid av andre selskaper.',
      note: 'Merk: Markedsførings- og reklamecookies brukes ikke.',
        },
    table: {
      provider: 'Leverandør',
      purpose: 'Formål',
      category: 'Kategori',
      essential: 'Essensiell',
      functional: 'Funksjonell',
      analytics: 'Statistikk',
      marketing: 'Markedsføring',
      mainEventsPurpose: 'Innlogging, økt, handlekurv, sikkerhet',
      stripePurpose: 'Betalingsbehandling og svindelforebygging',
      paypalPurpose: 'Betalingsbehandling, der tilgjengelig',
      googleMapsPurpose: 'Kart, steder, setekart',
      firebasePurpose: 'Push-varsler',
      analyticsPurpose: 'Pseudonymisert bruksanalyse for å forbedre plattformen',
      marketingPurpose: 'Personalisert innhold og reklame',
    },
  },
  da: {
    eyebrow: 'Juridisk',
    title: 'Cookiepolitik',
    intro: 'Hvordan Main Events bruger cookies og lignende teknologier, og hvordan du kan ændre dit samtykke når som helst.',
    sections: {
      whatTitle: '1. Hvad er cookies?',
      whatBody: 'Cookies er små tekstfiler, der gemmes på din enhed, når du bruger vores platform. Lignende teknologier som local storage har tilsvarende formål. De hjælper os med at holde platformen funktionel, sikker og brugervenlig.',
      legalTitle: '2. Retsgrundlag',
      legalBody: 'Vi bruger nødvendige cookies til at levere og drive platformen sikkert. Valgfrie cookies bruges kun med dit samtykke. Dit samtykke er frivilligt og kan ændres eller trækkes tilbage når som helst fremadrettet.',
      categoriesTitle: '3. Cookie-kategorier',
      servicesTitle: '4. Tjenester og cookies der bruges',
      servicesBody: 'Oversigten nedenfor viser vigtige udbydere, hvis teknologier kan bruges på Main Events. Detaljer om behandlingen findes i vores privatlivspolitik.',
      manageTitle: '5. Administrer samtykke',
      manageBody: 'Du kan ændre eller trække dit valg tilbage når som helst. Åbn cookie-indstillingerne:',
      browserBody: 'Du kan også administrere eller slette cookies i din browsers indstillinger. Nogle platformfunktioner kan derefter være utilgængelige.',
      openSettings: 'Åbn cookie-indstillinger',
      iosNoTracking: 'Vi bruger ikke cookies til tracking eller reklame, og vi sporer dig ikke på tværs af apps eller websites ejet af andre virksomheder.',
      note: 'Bemærk: Marketing- og reklamecookies bruges ikke.',
        },
    table: {
      provider: 'Udbyder',
      purpose: 'Formål',
      category: 'Kategori',
      essential: 'Nødvendig',
      functional: 'Funktionel',
      analytics: 'Statistik',
      marketing: 'Marketing',
      mainEventsPurpose: 'Login, session, kurv, sikkerhed',
      stripePurpose: 'Betalingsbehandling og svindelforebyggelse',
      paypalPurpose: 'Betalingsbehandling, hvor tilgængelig',
      googleMapsPurpose: 'Kort, steder, sædevisninger',
      firebasePurpose: 'Push-notifikationer',
      analyticsPurpose: 'Pseudonymiseret brugsanalyse for at forbedre platformen',
      marketingPurpose: 'Personaliseret indhold og reklame',
    },
  },
  pl: {
    eyebrow: 'Informacje prawne',
    title: 'Polityka cookies',
    intro: 'Jak Main Events używa plików cookie i podobnych technologii oraz jak możesz w każdej chwili zmienić zgodę.',
    sections: {
      whatTitle: '1. Czym są pliki cookie?',
      whatBody: 'Pliki cookie to małe pliki tekstowe zapisywane na Twoim urządzeniu podczas korzystania z naszej platformy. Podobne technologie, takie jak local storage, pełnią porównywalne funkcje. Pomagają nam utrzymać platformę funkcjonalną, bezpieczną i wygodną.',
      legalTitle: '2. Podstawa prawna',
      legalBody: 'Używamy niezbędnych cookies, aby udostępniać i bezpiecznie obsługiwać platformę. Opcjonalne cookies są używane tylko za Twoją zgodą. Zgoda jest dobrowolna i może zostać zmieniona lub wycofana w dowolnym momencie na przyszłość.',
      categoriesTitle: '3. Kategorie cookies',
      servicesTitle: '4. Używane usługi i cookies',
      servicesBody: 'Poniższy przegląd pokazuje ważnych dostawców, których technologie mogą być używane w Main Events. Szczegóły przetwarzania znajdują się w naszej Polityce prywatności.',
      manageTitle: '5. Zarządzanie zgodą',
      manageBody: 'Możesz zmienić lub wycofać swój wybór w dowolnym momencie. Otwórz ustawienia cookies:',
      browserBody: 'Możesz również zarządzać cookies lub usuwać je w ustawieniach przeglądarki. Niektóre funkcje platformy mogą wtedy nie być dostępne.',
      openSettings: 'Otwórz ustawienia cookies',
      iosNoTracking: 'Nie używamy cookies do śledzenia ani reklamy i nie śledzimy Cię w aplikacjach ani na stronach innych firm.',
      note: 'Uwaga: marketingowe i reklamowe cookies nie są używane.',
    },
    table: {
      provider: 'Dostawca',
      purpose: 'Cel',
      category: 'Kategoria',
      essential: 'Niezbędne',
      functional: 'Funkcjonalne',
      analytics: 'Statystyka',
      marketing: 'Marketing',
      mainEventsPurpose: 'Logowanie, sesja, koszyk, bezpieczeństwo',
      stripePurpose: 'Obsługa płatności i zapobieganie oszustwom',
      paypalPurpose: 'Obsługa płatności, jeśli dostępna',
      googleMapsPurpose: 'Mapy, miejsca, widoki miejsc siedzących',
      firebasePurpose: 'Powiadomienia push',
      analyticsPurpose: 'Pseudonimizowana analiza użycia w celu ulepszania platformy',
      marketingPurpose: 'Spersonalizowane treści i reklama',
    },
  },
  tr: {
    eyebrow: 'Yasal',
    title: 'Çerez Politikası',
    intro: 'Main Events’in çerezleri ve benzer teknolojileri nasıl kullandığı ve onayınızı istediğiniz zaman nasıl değiştirebileceğiniz.',
    sections: {
      whatTitle: '1. Çerez nedir?',
      whatBody: 'Çerezler, platformumuzu kullandığınızda cihazınıza kaydedilen küçük metin dosyalarıdır. Local storage gibi benzer teknolojiler de benzer amaçlara hizmet eder. Platformun işlevsel, güvenli ve kullanıcı dostu kalmasına yardımcı olurlar.',
      legalTitle: '2. Hukuki dayanak',
      legalBody: 'Platformu sunmak ve güvenli şekilde işletmek için zorunlu çerezleri kullanırız. İsteğe bağlı çerezler yalnızca onayınızla kullanılır. Onayınız gönüllüdür ve geleceğe yönelik olarak istediğiniz zaman değiştirilebilir veya geri çekilebilir.',
      categoriesTitle: '3. Çerez kategorileri',
      servicesTitle: '4. Kullanılan hizmetler ve çerezler',
      servicesBody: 'Aşağıdaki genel bakış, teknolojileri Main Events üzerinde kullanılabilecek önemli sağlayıcıları gösterir. İşleme detayları Gizlilik Politikamızda bulunabilir.',
      manageTitle: '5. Onayı yönet',
      manageBody: 'Seçiminizi istediğiniz zaman değiştirebilir veya geri çekebilirsiniz. Çerez ayarlarını açın:',
      browserBody: 'Alternatif olarak çerezleri tarayıcı ayarlarınızdan yönetebilir veya silebilirsiniz. Bu durumda platformun bazı işlevleri kullanılamayabilir.',
      openSettings: 'Çerez ayarlarını aç',
      iosNoTracking: 'Çerezleri takip veya reklam amacıyla kullanmıyoruz ve sizi başka şirketlere ait uygulamalar veya web siteleri arasında takip etmiyoruz.',
      note: 'Not: Pazarlama ve reklam çerezleri kullanılmaz.',
    },
    table: {
      provider: 'Sağlayıcı',
      purpose: 'Amaç',
      category: 'Kategori',
      essential: 'Zorunlu',
      functional: 'İşlevsel',
      analytics: 'İstatistik',
      marketing: 'Pazarlama',
      mainEventsPurpose: 'Giriş, oturum, sepet, güvenlik',
      stripePurpose: 'Ödeme işleme ve dolandırıcılık önleme',
      paypalPurpose: 'Mevcut olduğunda ödeme işleme',
      googleMapsPurpose: 'Haritalar, mekanlar, koltuk görünümleri',
      firebasePurpose: 'Push bildirimleri',
      analyticsPurpose: 'Platformu iyileştirmek için takma adlı kullanım analizi',
      marketingPurpose: 'Kişiselleştirilmiş içerik ve reklam',
    },
  },
  ru: {
    eyebrow: 'Правовая информация',
    title: 'Политика cookies',
    intro: 'Как Main Events использует cookies и похожие технологии, и как вы можете изменить согласие в любое время.',
    sections: {
      whatTitle: '1. Что такое cookies?',
      whatBody: 'Cookies — это небольшие текстовые файлы, которые сохраняются на вашем устройстве при использовании нашей платформы. Похожие технологии, например local storage, выполняют аналогичные функции. Они помогают нам поддерживать платформу функциональной, безопасной и удобной.',
      legalTitle: '2. Правовое основание',
      legalBody: 'Мы используем обязательные cookies для предоставления и безопасной работы платформы. Необязательные cookies используются только с вашего согласия. Согласие добровольно и может быть изменено или отозвано в любое время на будущее.',
      categoriesTitle: '3. Категории cookies',
      servicesTitle: '4. Используемые сервисы и cookies',
      servicesBody: 'Ниже перечислены важные поставщики, технологии которых могут использоваться в Main Events. Подробности обработки данных указаны в нашей Политике конфиденциальности.',
      manageTitle: '5. Управление согласием',
      manageBody: 'Вы можете изменить или отозвать свой выбор в любое время. Откройте настройки cookies:',
      browserBody: 'Также вы можете управлять cookies или удалять их в настройках браузера. Некоторые функции платформы после этого могут быть недоступны.',
      openSettings: 'Открыть настройки cookies',
      iosNoTracking: 'Мы не используем cookies для отслеживания или рекламы и не отслеживаем вас в приложениях или на сайтах других компаний.',
      note: 'Примечание: маркетинговые и рекламные cookies не используются.',
    },
    table: {
      provider: 'Поставщик',
      purpose: 'Цель',
      category: 'Категория',
      essential: 'Обязательные',
      functional: 'Функциональные',
      analytics: 'Статистика',
      marketing: 'Маркетинг',
      mainEventsPurpose: 'Вход, сессия, корзина, безопасность',
      stripePurpose: 'Обработка платежей и предотвращение мошенничества',
      paypalPurpose: 'Обработка платежей, если доступно',
      googleMapsPurpose: 'Карты, места проведения, схемы мест',
      firebasePurpose: 'Push-уведомления',
      analyticsPurpose: 'Псевдонимизированный анализ использования для улучшения платформы',
      marketingPurpose: 'Персонализированный контент и реклама',
    },
  },
};

const FALLBACK_COPY = COPY.en;

function getCopy(): CookiePolicyCopy {
  const lang = getCookieLanguage();
  return COPY[lang] ?? COPY[lang.split('-')[0]] ?? FALLBACK_COPY;
}

export default function CookiePolicy() {
  const copy = getCopy();
  const categories = getCategoryMeta();
  const mobileApp = isMobileAppWebView();

  const rows = [
    {
      provider: 'Main Events / Seuytel',
      purpose: copy.table.mainEventsPurpose,
      category: copy.table.essential,
    },
    {
      provider: 'Stripe',
      purpose: copy.table.stripePurpose,
      category: copy.table.essential,
    },
    {
      provider: 'PayPal',
      purpose: copy.table.paypalPurpose,
      category: copy.table.essential,
    },
    {
      provider: 'Google Maps / Places',
      purpose: copy.table.googleMapsPurpose,
      category: copy.table.functional,
    },
    {
      provider: 'Firebase Cloud Messaging',
      purpose: copy.table.firebasePurpose,
      category: copy.table.functional,
    },
    {
      provider: 'Statistics services',
      purpose: copy.table.analyticsPurpose,
      category: copy.table.analytics,
    },
  ];

  return (
    <LegalLayout
      eyebrow={copy.eyebrow}
      title={copy.title}
      intro={copy.intro}
      art={<CookieIllustration />}
    >
      <h2>{copy.sections.whatTitle}</h2>
      <p>{copy.sections.whatBody}</p>

      {mobileApp && <p className="se-callout">{copy.sections.iosNoTracking}</p>}

      <h2>{copy.sections.legalTitle}</h2>
      <p>{copy.sections.legalBody}</p>

      <h2>{copy.sections.categoriesTitle}</h2>
      {categories.map((cat) => (
        <div className="se-card" key={cat.key}>
          <h3 style={{ marginTop: 0 }}>{cat.title}</h3>
          <p style={{ marginBottom: 0 }}>{cat.desc}</p>
        </div>
      ))}

      <h2>{copy.sections.servicesTitle}</h2>
      <p>{copy.sections.servicesBody}</p>

      <div className="se-table-wrap">
        <table className="se-table">
          <thead>
            <tr>
              <th>{copy.table.provider}</th>
              <th>{copy.table.purpose}</th>
              <th>{copy.table.category}</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={`${row.provider}-${row.category}`}>
                <td>{row.provider}</td>
                <td>{row.purpose}</td>
                <td>{row.category}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {mobileApp && <p className="se-callout">{copy.sections.note}</p>}

      <h2>{copy.sections.manageTitle}</h2>
      <p>{copy.sections.manageBody}</p>

      <button type="button" className="se-reopen" onClick={openCookieSettings}>
        {copy.sections.openSettings}
      </button>

      <p>{copy.sections.browserBody}</p>
    </LegalLayout>
  );
}